import * as api from "../generated-api";
import { apiCall } from "../common";

export const primarySeries = (deal: api.DealAllOf): api.DealSeries => {
  return deal.series.find((series) => series.isPrimary);
};

export const seriesById = (
  deal: api.DealAllOf,
  seriesId: number
): api.DealSeries => {
  return deal.series.find((series) => {
    if (series.id == seriesId) {
      return series;
    }
  });
};

export const createDeal = (
  orgId: number,
  dealData: api.DealCreate,
  successCallback?: (deal: api.Deal) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Deal>(
    () => {
      return api.createDeal(orgId, dealData);
    },
    successCallback,
    errorCallback
  );
};

export const updateDeal = (
  orgId: number,
  dealId: number,
  dealData: api.DealUpdate,
  successCallback?: (deal: api.Deal) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Deal>(
    () => {
      return api.updateDeal(orgId, dealId, dealData);
    },
    successCallback,
    errorCallback
  );
};

export const getDealById = (
  orgId: number,
  dealId: number,
  successCallback?: (deal: api.Deal) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Deal>(
    () => {
      return api.getDealById(orgId, dealId);
    },
    successCallback,
    errorCallback
  );
};

export const getDeals = (
  successCallback?: (deals: api.Deal[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.Deal[]>(
    () => {
      return api.getDeals();
    },
    successCallback,
    errorCallback
  );
};

export const getInvestorsForAllDeals = (
  deals: api.Deal[],
  successCallback: (map: Map<number, api.DealInvestor[]>) => void
) => {
  Promise.all(
    deals.map((deal) => {
      return api.getDealInvestors(deal.organizationId, deal.id);
    })
  ).then((responses) => {
    const partialMapOfDealIdToInvestors = new Map<number, api.DealInvestor[]>();

    responses.forEach((response) => {
      const investors = response.data;

      if (investors.length) {
        partialMapOfDealIdToInvestors.set(investors[0].dealId, investors);
      }
    });

    const fullMapOfDealIdToInvestors = new Map<number, api.DealInvestor[]>();
    deals.forEach((deal) => {
      fullMapOfDealIdToInvestors.set(
        deal.id,
        partialMapOfDealIdToInvestors.get(deal.id)
          ? partialMapOfDealIdToInvestors.get(deal.id)
          : []
      );
    });

    successCallback(fullMapOfDealIdToInvestors);
  });
};
